import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=e0a40f70&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=e0a40f70&lang=scss&scoped=true&"
import style1 from "./contact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a40f70",
  null
  
)

export default component.exports